import React, { useState, useEffect, Fragment } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import axiosConfig from "../../services/axiosConfig";
import setHeader from "../../components/Functions/setHeader";
import SweetAlert from "sweetalert2";
import { Link } from "react-router-dom";
import { SITE_URL } from "../../services/Const";
import NoDataHandler from "../../components/common/NoDataHandler";
import LoadingComponent from "../../components/common/LoadingComponent";

const AllBanners = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getData();

  }, []);

  const getData = () => {
    setLoading(true);
    setData([]); // Reset data before fetching new data

    axiosConfig.get("banner-list", setHeader())
      .then((res) => {
        setData(res.data.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const DeleteData = (id) => {
    SweetAlert.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axiosConfig
          .get(`delete-banner/${id}`, setHeader())
          .then((res) => {
            if (!res.data.error) {
              SweetAlert.fire({
                title: "Success",
                text: res.data.messages,
                icon: "success",
              });
              getData(); // Refresh the list
            } else {
              SweetAlert.fire({
                title: "Oops!",
                text: res.data.messages,
                icon: "error",
              });
            }
          })
          .catch((error) => {
            console.error("Error deleting data:", error);
            SweetAlert.fire({
              title: "Error",
              text: "An error occurred while deleting the data.",
              icon: "error",
            });
          });
      }
    });
  };

  if (loading) {
    return (
      <LoadingComponent />
    );
  }
  if (data.length === 0) {
    return <NoDataHandler title='No Home Banners Fount' />;
  }
  return (
    <Fragment>
      <Breadcrumb title="Banner List" parent="Home Banners" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">{"#"}</th>
                    <th scope="col">{"Banner text"}</th>
                    <th scope="col">{"Status"}</th>
                    <th scope="col">{"Order"}</th>
                    <th scope="col">{"Banner image"}</th>
                    <th scope="col">{"Action"}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => {
                    return (
                      <tr key={index}>
                        <th scope="row">{index + 1}</th>
                        <td>{item.banner_text || 'No Text Added'}</td>
                        <td>{item.banner_status == "0" ? 'Inactive' : 'Active'}</td>
                        <td>{item.banner_order}</td>
                        <td>
                          <img
                            src={item.banner_image}
                            alt="Banner"
                            width="100"
                            height="50"
                          />
                        </td>

                        <td>
                          <Link
                            to={`/pages/home-banners/edit/${item.id}`}
                            className="btn btn-xs btn-outline-success"
                          >
                            Edit
                          </Link>
                          &nbsp;
                          <button
                            title="Delete"
                            className="btn btn-xs btn-outline-danger"
                            onClick={(e) => DeleteData(item.id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AllBanners;
